var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowToBottomRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 123,
    viewBox: "0 0 209 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.511719C9.21491 17.5696 17.1156 26.8637 32.8708 33.3098C47.0988 39.1311 64.9488 38.4392 79.8773 38.8354C98.3601 39.326 131.825 48.6243 133.59 75.4678C134.962 96.3112 117.029 112.061 101.813 98.3551C95.9469 93.0713 96.0431 81.0854 101.403 75.252C107.193 68.9511 117.907 69.627 125.047 70.8938C144.222 74.2965 149.371 99.1334 164.099 109.975C177.858 120.104 191.518 117.441 206.326 112.122C207.595 111.667 205.064 117.468 204.554 118.976C202.685 124.507 204.453 122.492 205.866 118.311C206.775 115.621 209.91 110.467 206.313 110.551C203.719 110.611 198.963 108.671 196.469 107.502",
    stroke: "#0281C5",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToBottomRight);
export default __webpack_public_path__ + "static/media/arrow-to-bottom-right.99c64e41ac5b023654685ccb9a625969.svg";
export { ForwardRef as ReactComponent };